module.exports = __webpack_public_path__ + "img/japan-lung-cancer-male.cc45cb09.png";